import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import useEmailValidation from "../../Global/Hooks/emailValidation";

import RegisterWrapper from "../../Components/Wrappers/RegisterWrapper";
import Button from "../../UI/Button";
import Checkbox from "../../UI/Checkbox";
import Input from "../../UI/Input";
import useRegisterApi from "../../Global/Api/Signup/registerApi";
import {CustomSelect} from "../../UI/Select";
import {setCertificate} from "../../Store/Slice/dashboardSlice";
import useCountriesApi from "../../Global/Api/Signup/countriesApi";
import {useSelector} from "react-redux";

export default function Signup() {
  const navigate = useNavigate();
  const emailValidation = useEmailValidation();
  const registerApi = useRegisterApi();
  const [check, setCheck] = useState(false);
  const isButtonDisabled = !emailValidation.isValid || !check;

  const { selectedBusinessUnit } = useSelector((state) => state.rootReducer.registerSlice);

  const handleEmailChange = (event) => {
    emailValidation.handleChange(event);
    emailValidation.validateEmail(event.target.value);
  };

  const handleCheckboxChange = (isChecked) => {
    setCheck(isChecked);
  };

  const registerUser = () => {
    registerApi.send({ email: emailValidation.value, business_unit_id: selectedBusinessUnit.id });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    registerUser();
  };

  useEffect(  () => {
    if (localStorage.getItem("techsbook_customer_portal_token")?.length > 0) {
      navigate("/");
    }
    if(!selectedBusinessUnit || !Object.keys(selectedBusinessUnit).length) {
      navigate("/select-country")
    }
  }, []);

  return (
    <RegisterWrapper image="/assets/images/register-3.svg">
      <h1 className="register__title">Let’s get started</h1>
      <form onSubmit={handleSubmit} className="register__form">
        <div className="register__input mt24">
          <Input
            label="Email"
            placeholder="Enter email"
            type="email"
            id="email"
            value={emailValidation.value}
            handleChange={handleEmailChange}
          />
        </div>
        <div className="register__checkbox mt20">
          <Checkbox
            id="service"
            label="I agree to the"
            linkText="Service agreement"
            link={`/service-agreement`}
            targetBlank={true}
            onChange={handleCheckboxChange}
            defaultChecked={false}
          />
        </div>
        <div className="register__btn mt24">
          <Button
            text="Get started"
            type="primary"
            disabled={isButtonDisabled}
            topPadding={12}
            bottomPadding={12}
          />
        </div>
      </form>
      <div className="register__footer mt24">
        Already have an account?{" "}
        <NavLink to="/login" className="register__link">
          Log in
        </NavLink>
      </div>
    </RegisterWrapper>
  );
}
